module.exports = __webpack_public_path__ + "static/media/ANDROS SPIRIT PHONOSTAGE.fac4af89.png";